(() => {
  const initialize = async (root = document) => {
    for (const collection of root.querySelectorAll('.av-collection')) {
      if (collection.dataset.avInitialized) continue;
      collection.dataset.avInitialized = 'true';
      const controls = collection.querySelector('.av-collection-controls');
      const topicForm = controls.querySelector('.av-topic-form');
      const sortForm = controls.querySelector('.av-collection-sort');
      const menu = controls.querySelector('.av-topic-menu');
      const currentUrl = new URL(window.location.href);
      const preview = currentUrl.searchParams.get('preview_theme_id');
      const inputs = [...(topicForm?.querySelectorAll('input[type=checkbox]') || [])];
      const requested = currentUrl.searchParams.getAll('av_topics').flatMap(value => value.split(','));
      const selected = requested.length ? inputs.filter(input => requested.includes(input.value)).map(input => input.value) : inputs.filter(input => input.checked).map(input => input.value);
      inputs.forEach(input => { input.checked = selected.includes(input.value); });
      const withPreview = (url) => { if (preview) url.searchParams.set('preview_theme_id', preview); return url; };
      const destination = (topics) => {
        const single = topics.length === 1 ? inputs.find(input => input.value === topics[0]) : null;
        const url = withPreview(new URL(single?.dataset.url || controls.dataset.allUrl, window.location.origin));
        if (topics.length > 1) url.searchParams.set('av_topics', topics.join(','));
        const sort = sortForm?.querySelector('select').value || currentUrl.searchParams.get('sort_by');
        if (sort) url.searchParams.set('sort_by', sort);
        return url;
      };
      topicForm?.addEventListener('submit', event => {
        event.preventDefault();
        window.location.assign(destination(inputs.filter(input => input.checked).map(input => input.value)));
      });
      const closeMenu = () => {
        inputs.forEach(input => { input.checked = selected.includes(input.value); });
        menu.open = false;
        menu.querySelector('summary').focus();
      };
      controls.querySelector('.av-topic-close')?.addEventListener('click', closeMenu);
      menu?.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); closeMenu(); } });
      const reset = topicForm?.querySelector('.av-topic-reset');
      if (reset) reset.href = destination([]).href;
      if (sortForm) {
        if (selected.length > 1) {
          const input = document.createElement('input'); input.type = 'hidden'; input.name = 'av_topics'; input.value = selected.join(','); sortForm.append(input);
        }
        if (preview) {
          const input = document.createElement('input'); input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = preview; sortForm.append(input);
        }
        sortForm.querySelector('select').addEventListener('change', () => sortForm.requestSubmit());
      }
      const grid = collection.querySelector('#product-grid');
      if (!grid) continue;
      const error = collection.querySelector('.av-topic-error');
      try {
        let next = collection.dataset.nextPage;
        const seenPages = new Set();
        while (next) {
          const url = withPreview(new URL(next, window.location.origin));
          url.searchParams.set('section_id', collection.dataset.sectionId);
          if (seenPages.has(url.href)) throw new Error('Repeated collection page');
          seenPages.add(url.href);
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Collection unavailable');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('.av-collection');
          if (!page) throw new Error('Collection markup missing');
          page.querySelectorAll('#product-grid > [data-av-product-id]').forEach(card => grid.append(card));
          next = page.dataset.nextPage;
        }
        const ids = new Set();
        const cards = [...grid.querySelectorAll(':scope > [data-av-product-id]')].filter(card => {
          if (ids.has(card.dataset.avProductId)) { card.remove(); return false; }
          ids.add(card.dataset.avProductId); return true;
        });
        const matches = cards.filter(card => selected.length === 0 || selected.some(topic => card.dataset.avTopics.includes(`|${topic}|`)));
        const count = collection.querySelector('.av-collection-count');
        count.textContent = count.dataset.countLabel.replace('[count]', matches.length);
        const pageSize = Number(collection.dataset.pageSize) || 16;
        const pages = Math.max(1, Math.ceil(matches.length / pageSize));
        const page = Math.min(pages, Math.max(1, Number(currentUrl.searchParams.get('av_page')) || Number(currentUrl.searchParams.get('page')) || 1));
        cards.forEach(card => { card.hidden = true; });
        matches.slice((page - 1) * pageSize, page * pageSize).forEach(card => { card.hidden = false; });
        collection.querySelector('.av-topic-empty').hidden = matches.length > 0;
        collection.querySelectorAll('.av-native-pagination').forEach(pagination => { pagination.hidden = true; });
        const pagination = collection.querySelector('.av-topic-pagination');
        if (pagination && pages > 1) {
          pagination.hidden = false;
          for (let number = 1; number <= pages; number++) {
            const url = new URL(currentUrl); url.searchParams.delete('page'); url.searchParams.set('av_page', number);
            const link = document.createElement('a'); link.href = url.pathname + url.search + '#ProductGridContainer'; link.textContent = number;
            link.setAttribute('aria-label', collection.dataset.pageLabel.replace('[number]', number));
            if (number === page) link.setAttribute('aria-current', 'page');
            pagination.append(link);
          }
        }
        collection.classList.add('av-filter-ready');
      } catch (failure) {
        error.hidden = false;
        if (selected.length > 1) {
          grid.hidden = true;
          collection.querySelector('.av-collection-count').hidden = true;
        }
      }
    }
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
